/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../pages/__root'
import { Route as AuthenticatedRouteImport } from './../pages/_authenticated'
import { Route as LoginIndexRouteImport } from './../pages/login/index'
import { Route as AuthenticatedIndexRouteImport } from './../pages/_authenticated/index'
import { Route as AuthenticatedUnauthorizedIndexRouteImport } from './../pages/_authenticated/unauthorized/index'
import { Route as AuthenticatedTutorAiIndexRouteImport } from './../pages/_authenticated/tutor-ai/index'
import { Route as AuthenticatedSlideLibraryIndexRouteImport } from './../pages/_authenticated/slide-library/index'
import { Route as AuthenticatedSlideEditorIndexRouteImport } from './../pages/_authenticated/slide-editor/index'
import { Route as AuthenticatedSeriesIndexRouteImport } from './../pages/_authenticated/series/index'
import { Route as AuthenticatedQuestionLibraryIndexRouteImport } from './../pages/_authenticated/question-library/index'
import { Route as AuthenticatedPersonsIndexRouteImport } from './../pages/_authenticated/persons/index'
import { Route as AuthenticatedNotificationIndexRouteImport } from './../pages/_authenticated/notification/index'
import { Route as AuthenticatedIndividualPaymentIndexRouteImport } from './../pages/_authenticated/individual-payment/index'
import { Route as AuthenticatedExamsIndexRouteImport } from './../pages/_authenticated/exams/index'
import { Route as AuthenticatedEnrollmentsIndexRouteImport } from './../pages/_authenticated/enrollments/index'
import { Route as AuthenticatedClassPlanningIndexRouteImport } from './../pages/_authenticated/class-planning/index'
import { Route as AuthenticatedClassModulesIndexRouteImport } from './../pages/_authenticated/class-modules/index'
import { Route as AuthenticatedBannersIndexRouteImport } from './../pages/_authenticated/banners/index'
import { Route as AuthenticatedAccessManagementIndexRouteImport } from './../pages/_authenticated/access-management/index'
import { Route as AuthenticatedTutorAiUsageIndexRouteImport } from './../pages/_authenticated/tutor-ai/usage/index'
import { Route as AuthenticatedTutorAiStudentsIndexRouteImport } from './../pages/_authenticated/tutor-ai/students/index'
import { Route as AuthenticatedTutorAiConfigIndexRouteImport } from './../pages/_authenticated/tutor-ai/config/index'
import { Route as AuthenticatedTutorAiClassesIndexRouteImport } from './../pages/_authenticated/tutor-ai/classes/index'
import { Route as AuthenticatedSeriesCreateIndexRouteImport } from './../pages/_authenticated/series/create/index'
import { Route as AuthenticatedSeriesSerieIdIndexRouteImport } from './../pages/_authenticated/series/$serieId/index'
import { Route as AuthenticatedQuestionLibraryNewIndexRouteImport } from './../pages/_authenticated/question-library/new/index'
import { Route as AuthenticatedQuestionLibraryQuestionIdIndexRouteImport } from './../pages/_authenticated/question-library/$questionId/index'
import { Route as AuthenticatedPersonsPaymentsIndexRouteImport } from './../pages/_authenticated/persons/payments/index'
import { Route as AuthenticatedPersonsCreateIndexRouteImport } from './../pages/_authenticated/persons/create/index'
import { Route as AuthenticatedPersonsIdIndexRouteImport } from './../pages/_authenticated/persons/$id/index'
import { Route as AuthenticatedNotificationCreateIndexRouteImport } from './../pages/_authenticated/notification/create/index'
import { Route as AuthenticatedNotificationIdIndexRouteImport } from './../pages/_authenticated/notification/$id/index'
import { Route as AuthenticatedLocationStatesIndexRouteImport } from './../pages/_authenticated/location/states/index'
import { Route as AuthenticatedLocationCountriesIndexRouteImport } from './../pages/_authenticated/location/countries/index'
import { Route as AuthenticatedLocationCitiesIndexRouteImport } from './../pages/_authenticated/location/cities/index'
import { Route as AuthenticatedIndividualPaymentCreateIndexRouteImport } from './../pages/_authenticated/individual-payment/create/index'
import { Route as AuthenticatedIndividualPaymentFinancialPersonIdIndexRouteImport } from './../pages/_authenticated/individual-payment/$financialPersonId/index'
import { Route as AuthenticatedExamsCreateIndexRouteImport } from './../pages/_authenticated/exams/create/index'
import { Route as AuthenticatedExamsIdIndexRouteImport } from './../pages/_authenticated/exams/$id/index'
import { Route as AuthenticatedExamRevisionIndexRouteImport } from './../pages/_authenticated/exam/revision/index'
import { Route as AuthenticatedExamGradeConfigIndexRouteImport } from './../pages/_authenticated/exam/grade-config/index'
import { Route as AuthenticatedExamCorrectionDashboardIndexRouteImport } from './../pages/_authenticated/exam/correction-dashboard/index'
import { Route as AuthenticatedEnrollmentsBatchStatusIndexRouteImport } from './../pages/_authenticated/enrollments/batch-status/index'
import { Route as AuthenticatedEnrollmentsEnrollmentIdIndexRouteImport } from './../pages/_authenticated/enrollments/$enrollmentId/index'
import { Route as AuthenticatedClassModulesCreateIndexRouteImport } from './../pages/_authenticated/class-modules/create/index'
import { Route as AuthenticatedClassModulesIdIndexRouteImport } from './../pages/_authenticated/class-modules/$id/index'
import { Route as AuthenticatedBannersCreateIndexRouteImport } from './../pages/_authenticated/banners/create/index'
import { Route as AuthenticatedBannersBannerIdIndexRouteImport } from './../pages/_authenticated/banners/$bannerId/index'
import { Route as AuthenticatedAccessManagementRoleIdIndexRouteImport } from './../pages/_authenticated/access-management/$roleId/index'
import { Route as AuthenticatedTutorAiStudentsPersonIdIndexRouteImport } from './../pages/_authenticated/tutor-ai/students/$personId/index'
import { Route as AuthenticatedTutorAiClassesClassStudentIdIndexRouteImport } from './../pages/_authenticated/tutor-ai/classes/$classStudentId/index'
import { Route as AuthenticatedSeriesSerieIdVideosIndexRouteImport } from './../pages/_authenticated/series/$serieId/videos/index'
import { Route as AuthenticatedSeriesSerieIdLangsIndexRouteImport } from './../pages/_authenticated/series/$serieId/langs/index'
import { Route as AuthenticatedPersonsIdResumeIndexRouteImport } from './../pages/_authenticated/persons/$id/resume/index'
import { Route as AuthenticatedPersonsIdPaymentsIndexRouteImport } from './../pages/_authenticated/persons/$id/payments/index'
import { Route as AuthenticatedIndividualPaymentFinancialPersonIdParcelsIndexRouteImport } from './../pages/_authenticated/individual-payment/$financialPersonId/parcels/index'
import { Route as AuthenticatedIndividualPaymentFinancialPersonIdConsolidationIndexRouteImport } from './../pages/_authenticated/individual-payment/$financialPersonId/consolidation/index'
import { Route as AuthenticatedExamsIdQuestionsIndexRouteImport } from './../pages/_authenticated/exams/$id/questions/index'
import { Route as AuthenticatedExamsIdPreviewIndexRouteImport } from './../pages/_authenticated/exams/$id/preview/index'
import { Route as AuthenticatedExamsIdLanguagesIndexRouteImport } from './../pages/_authenticated/exams/$id/languages/index'
import { Route as AuthenticatedExamCorrectionExamPublishIdIndexRouteImport } from './../pages/_authenticated/exam/correction/$examPublishId/index'
import { Route as AuthenticatedSeriesSerieIdVideosCreateIndexRouteImport } from './../pages/_authenticated/series/$serieId/videos/create/index'
import { Route as AuthenticatedSeriesSerieIdVideosVideoIdIndexRouteImport } from './../pages/_authenticated/series/$serieId/videos/$videoId/index'
import { Route as AuthenticatedSeriesSerieIdLangsCreateIndexRouteImport } from './../pages/_authenticated/series/$serieId/langs/create/index'
import { Route as AuthenticatedSeriesSerieIdLangsLangIdIndexRouteImport } from './../pages/_authenticated/series/$serieId/langs/$langId/index'
import { Route as AuthenticatedPersonsPaymentsPlansPlanIdIndexRouteImport } from './../pages/_authenticated/persons/payments/plans/$planId/index'
import { Route as AuthenticatedLocationCountriesCountryIdLangsIndexRouteImport } from './../pages/_authenticated/location/countries/$countryId/langs/index'
import { Route as AuthenticatedIndividualPaymentFinancialPersonIdParcelsCreateIndexRouteImport } from './../pages/_authenticated/individual-payment/$financialPersonId/parcels/create/index'
import { Route as AuthenticatedExamRevisionExamIdVisualizeIndexRouteImport } from './../pages/_authenticated/exam/revision/$examId/visualize/index'
import { Route as AuthenticatedExamRevisionExamIdReviewIndexRouteImport } from './../pages/_authenticated/exam/revision/$examId/review/index'
import { Route as AuthenticatedExamRevisionExamIdLanguagesIndexRouteImport } from './../pages/_authenticated/exam/revision/$examId/languages/index'
import { Route as AuthenticatedSeriesSerieIdVideosVideoIdLangsIndexRouteImport } from './../pages/_authenticated/series/$serieId/videos/$videoId/langs/index'
import { Route as AuthenticatedPersonsPaymentsPlansPlanIdParcelsIndexRouteImport } from './../pages/_authenticated/persons/payments/plans/$planId/parcels/index'
import { Route as AuthenticatedIndividualPaymentFinancialPersonIdParcelsParcelIdEditIndexRouteImport } from './../pages/_authenticated/individual-payment/$financialPersonId/parcels/$parcelId/edit/index'
import { Route as AuthenticatedSeriesSerieIdVideosVideoIdLangsCreateIndexRouteImport } from './../pages/_authenticated/series/$serieId/videos/$videoId/langs/create/index'
import { Route as AuthenticatedSeriesSerieIdVideosVideoIdLangsLangIdIndexRouteImport } from './../pages/_authenticated/series/$serieId/videos/$videoId/langs/$langId/index'
import { Route as AuthenticatedExamRevisionExamIdLanguagesLangIdTranslateIndexRouteImport } from './../pages/_authenticated/exam/revision/$examId/languages/$langId/translate/index'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUnauthorizedIndexRoute =
  AuthenticatedUnauthorizedIndexRouteImport.update({
    id: '/unauthorized/',
    path: '/unauthorized/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTutorAiIndexRoute =
  AuthenticatedTutorAiIndexRouteImport.update({
    id: '/tutor-ai/',
    path: '/tutor-ai/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSlideLibraryIndexRoute =
  AuthenticatedSlideLibraryIndexRouteImport.update({
    id: '/slide-library/',
    path: '/slide-library/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSlideEditorIndexRoute =
  AuthenticatedSlideEditorIndexRouteImport.update({
    id: '/slide-editor/',
    path: '/slide-editor/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSeriesIndexRoute =
  AuthenticatedSeriesIndexRouteImport.update({
    id: '/series/',
    path: '/series/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedQuestionLibraryIndexRoute =
  AuthenticatedQuestionLibraryIndexRouteImport.update({
    id: '/question-library/',
    path: '/question-library/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPersonsIndexRoute =
  AuthenticatedPersonsIndexRouteImport.update({
    id: '/persons/',
    path: '/persons/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNotificationIndexRoute =
  AuthenticatedNotificationIndexRouteImport.update({
    id: '/notification/',
    path: '/notification/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIndividualPaymentIndexRoute =
  AuthenticatedIndividualPaymentIndexRouteImport.update({
    id: '/individual-payment/',
    path: '/individual-payment/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedExamsIndexRoute = AuthenticatedExamsIndexRouteImport.update({
  id: '/exams/',
  path: '/exams/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedEnrollmentsIndexRoute =
  AuthenticatedEnrollmentsIndexRouteImport.update({
    id: '/enrollments/',
    path: '/enrollments/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClassPlanningIndexRoute =
  AuthenticatedClassPlanningIndexRouteImport.update({
    id: '/class-planning/',
    path: '/class-planning/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClassModulesIndexRoute =
  AuthenticatedClassModulesIndexRouteImport.update({
    id: '/class-modules/',
    path: '/class-modules/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBannersIndexRoute =
  AuthenticatedBannersIndexRouteImport.update({
    id: '/banners/',
    path: '/banners/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccessManagementIndexRoute =
  AuthenticatedAccessManagementIndexRouteImport.update({
    id: '/access-management/',
    path: '/access-management/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTutorAiUsageIndexRoute =
  AuthenticatedTutorAiUsageIndexRouteImport.update({
    id: '/tutor-ai/usage/',
    path: '/tutor-ai/usage/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTutorAiStudentsIndexRoute =
  AuthenticatedTutorAiStudentsIndexRouteImport.update({
    id: '/tutor-ai/students/',
    path: '/tutor-ai/students/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTutorAiConfigIndexRoute =
  AuthenticatedTutorAiConfigIndexRouteImport.update({
    id: '/tutor-ai/config/',
    path: '/tutor-ai/config/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTutorAiClassesIndexRoute =
  AuthenticatedTutorAiClassesIndexRouteImport.update({
    id: '/tutor-ai/classes/',
    path: '/tutor-ai/classes/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSeriesCreateIndexRoute =
  AuthenticatedSeriesCreateIndexRouteImport.update({
    id: '/series/create/',
    path: '/series/create/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSeriesSerieIdIndexRoute =
  AuthenticatedSeriesSerieIdIndexRouteImport.update({
    id: '/series/$serieId/',
    path: '/series/$serieId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedQuestionLibraryNewIndexRoute =
  AuthenticatedQuestionLibraryNewIndexRouteImport.update({
    id: '/question-library/new/',
    path: '/question-library/new/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedQuestionLibraryQuestionIdIndexRoute =
  AuthenticatedQuestionLibraryQuestionIdIndexRouteImport.update({
    id: '/question-library/$questionId/',
    path: '/question-library/$questionId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPersonsPaymentsIndexRoute =
  AuthenticatedPersonsPaymentsIndexRouteImport.update({
    id: '/persons/payments/',
    path: '/persons/payments/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPersonsCreateIndexRoute =
  AuthenticatedPersonsCreateIndexRouteImport.update({
    id: '/persons/create/',
    path: '/persons/create/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPersonsIdIndexRoute =
  AuthenticatedPersonsIdIndexRouteImport.update({
    id: '/persons/$id/',
    path: '/persons/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNotificationCreateIndexRoute =
  AuthenticatedNotificationCreateIndexRouteImport.update({
    id: '/notification/create/',
    path: '/notification/create/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNotificationIdIndexRoute =
  AuthenticatedNotificationIdIndexRouteImport.update({
    id: '/notification/$id/',
    path: '/notification/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLocationStatesIndexRoute =
  AuthenticatedLocationStatesIndexRouteImport.update({
    id: '/location/states/',
    path: '/location/states/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLocationCountriesIndexRoute =
  AuthenticatedLocationCountriesIndexRouteImport.update({
    id: '/location/countries/',
    path: '/location/countries/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLocationCitiesIndexRoute =
  AuthenticatedLocationCitiesIndexRouteImport.update({
    id: '/location/cities/',
    path: '/location/cities/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIndividualPaymentCreateIndexRoute =
  AuthenticatedIndividualPaymentCreateIndexRouteImport.update({
    id: '/individual-payment/create/',
    path: '/individual-payment/create/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIndividualPaymentFinancialPersonIdIndexRoute =
  AuthenticatedIndividualPaymentFinancialPersonIdIndexRouteImport.update({
    id: '/individual-payment/$financialPersonId/',
    path: '/individual-payment/$financialPersonId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedExamsCreateIndexRoute =
  AuthenticatedExamsCreateIndexRouteImport.update({
    id: '/exams/create/',
    path: '/exams/create/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedExamsIdIndexRoute =
  AuthenticatedExamsIdIndexRouteImport.update({
    id: '/exams/$id/',
    path: '/exams/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedExamRevisionIndexRoute =
  AuthenticatedExamRevisionIndexRouteImport.update({
    id: '/exam/revision/',
    path: '/exam/revision/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedExamGradeConfigIndexRoute =
  AuthenticatedExamGradeConfigIndexRouteImport.update({
    id: '/exam/grade-config/',
    path: '/exam/grade-config/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedExamCorrectionDashboardIndexRoute =
  AuthenticatedExamCorrectionDashboardIndexRouteImport.update({
    id: '/exam/correction-dashboard/',
    path: '/exam/correction-dashboard/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEnrollmentsBatchStatusIndexRoute =
  AuthenticatedEnrollmentsBatchStatusIndexRouteImport.update({
    id: '/enrollments/batch-status/',
    path: '/enrollments/batch-status/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEnrollmentsEnrollmentIdIndexRoute =
  AuthenticatedEnrollmentsEnrollmentIdIndexRouteImport.update({
    id: '/enrollments/$enrollmentId/',
    path: '/enrollments/$enrollmentId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClassModulesCreateIndexRoute =
  AuthenticatedClassModulesCreateIndexRouteImport.update({
    id: '/class-modules/create/',
    path: '/class-modules/create/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClassModulesIdIndexRoute =
  AuthenticatedClassModulesIdIndexRouteImport.update({
    id: '/class-modules/$id/',
    path: '/class-modules/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBannersCreateIndexRoute =
  AuthenticatedBannersCreateIndexRouteImport.update({
    id: '/banners/create/',
    path: '/banners/create/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBannersBannerIdIndexRoute =
  AuthenticatedBannersBannerIdIndexRouteImport.update({
    id: '/banners/$bannerId/',
    path: '/banners/$bannerId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccessManagementRoleIdIndexRoute =
  AuthenticatedAccessManagementRoleIdIndexRouteImport.update({
    id: '/access-management/$roleId/',
    path: '/access-management/$roleId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTutorAiStudentsPersonIdIndexRoute =
  AuthenticatedTutorAiStudentsPersonIdIndexRouteImport.update({
    id: '/tutor-ai/students/$personId/',
    path: '/tutor-ai/students/$personId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTutorAiClassesClassStudentIdIndexRoute =
  AuthenticatedTutorAiClassesClassStudentIdIndexRouteImport.update({
    id: '/tutor-ai/classes/$classStudentId/',
    path: '/tutor-ai/classes/$classStudentId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSeriesSerieIdVideosIndexRoute =
  AuthenticatedSeriesSerieIdVideosIndexRouteImport.update({
    id: '/series/$serieId/videos/',
    path: '/series/$serieId/videos/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSeriesSerieIdLangsIndexRoute =
  AuthenticatedSeriesSerieIdLangsIndexRouteImport.update({
    id: '/series/$serieId/langs/',
    path: '/series/$serieId/langs/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPersonsIdResumeIndexRoute =
  AuthenticatedPersonsIdResumeIndexRouteImport.update({
    id: '/persons/$id/resume/',
    path: '/persons/$id/resume/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPersonsIdPaymentsIndexRoute =
  AuthenticatedPersonsIdPaymentsIndexRouteImport.update({
    id: '/persons/$id/payments/',
    path: '/persons/$id/payments/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIndividualPaymentFinancialPersonIdParcelsIndexRoute =
  AuthenticatedIndividualPaymentFinancialPersonIdParcelsIndexRouteImport.update(
    {
      id: '/individual-payment/$financialPersonId/parcels/',
      path: '/individual-payment/$financialPersonId/parcels/',
      getParentRoute: () => AuthenticatedRoute,
    } as any,
  )
const AuthenticatedIndividualPaymentFinancialPersonIdConsolidationIndexRoute =
  AuthenticatedIndividualPaymentFinancialPersonIdConsolidationIndexRouteImport.update(
    {
      id: '/individual-payment/$financialPersonId/consolidation/',
      path: '/individual-payment/$financialPersonId/consolidation/',
      getParentRoute: () => AuthenticatedRoute,
    } as any,
  )
const AuthenticatedExamsIdQuestionsIndexRoute =
  AuthenticatedExamsIdQuestionsIndexRouteImport.update({
    id: '/exams/$id/questions/',
    path: '/exams/$id/questions/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedExamsIdPreviewIndexRoute =
  AuthenticatedExamsIdPreviewIndexRouteImport.update({
    id: '/exams/$id/preview/',
    path: '/exams/$id/preview/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedExamsIdLanguagesIndexRoute =
  AuthenticatedExamsIdLanguagesIndexRouteImport.update({
    id: '/exams/$id/languages/',
    path: '/exams/$id/languages/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedExamCorrectionExamPublishIdIndexRoute =
  AuthenticatedExamCorrectionExamPublishIdIndexRouteImport.update({
    id: '/exam/correction/$examPublishId/',
    path: '/exam/correction/$examPublishId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSeriesSerieIdVideosCreateIndexRoute =
  AuthenticatedSeriesSerieIdVideosCreateIndexRouteImport.update({
    id: '/series/$serieId/videos/create/',
    path: '/series/$serieId/videos/create/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSeriesSerieIdVideosVideoIdIndexRoute =
  AuthenticatedSeriesSerieIdVideosVideoIdIndexRouteImport.update({
    id: '/series/$serieId/videos/$videoId/',
    path: '/series/$serieId/videos/$videoId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSeriesSerieIdLangsCreateIndexRoute =
  AuthenticatedSeriesSerieIdLangsCreateIndexRouteImport.update({
    id: '/series/$serieId/langs/create/',
    path: '/series/$serieId/langs/create/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSeriesSerieIdLangsLangIdIndexRoute =
  AuthenticatedSeriesSerieIdLangsLangIdIndexRouteImport.update({
    id: '/series/$serieId/langs/$langId/',
    path: '/series/$serieId/langs/$langId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPersonsPaymentsPlansPlanIdIndexRoute =
  AuthenticatedPersonsPaymentsPlansPlanIdIndexRouteImport.update({
    id: '/persons/payments/plans/$planId/',
    path: '/persons/payments/plans/$planId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLocationCountriesCountryIdLangsIndexRoute =
  AuthenticatedLocationCountriesCountryIdLangsIndexRouteImport.update({
    id: '/location/countries/$countryId/langs/',
    path: '/location/countries/$countryId/langs/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIndividualPaymentFinancialPersonIdParcelsCreateIndexRoute =
  AuthenticatedIndividualPaymentFinancialPersonIdParcelsCreateIndexRouteImport.update(
    {
      id: '/individual-payment/$financialPersonId/parcels/create/',
      path: '/individual-payment/$financialPersonId/parcels/create/',
      getParentRoute: () => AuthenticatedRoute,
    } as any,
  )
const AuthenticatedExamRevisionExamIdVisualizeIndexRoute =
  AuthenticatedExamRevisionExamIdVisualizeIndexRouteImport.update({
    id: '/exam/revision/$examId/visualize/',
    path: '/exam/revision/$examId/visualize/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedExamRevisionExamIdReviewIndexRoute =
  AuthenticatedExamRevisionExamIdReviewIndexRouteImport.update({
    id: '/exam/revision/$examId/review/',
    path: '/exam/revision/$examId/review/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedExamRevisionExamIdLanguagesIndexRoute =
  AuthenticatedExamRevisionExamIdLanguagesIndexRouteImport.update({
    id: '/exam/revision/$examId/languages/',
    path: '/exam/revision/$examId/languages/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSeriesSerieIdVideosVideoIdLangsIndexRoute =
  AuthenticatedSeriesSerieIdVideosVideoIdLangsIndexRouteImport.update({
    id: '/series/$serieId/videos/$videoId/langs/',
    path: '/series/$serieId/videos/$videoId/langs/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPersonsPaymentsPlansPlanIdParcelsIndexRoute =
  AuthenticatedPersonsPaymentsPlansPlanIdParcelsIndexRouteImport.update({
    id: '/persons/payments/plans/$planId/parcels/',
    path: '/persons/payments/plans/$planId/parcels/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIndividualPaymentFinancialPersonIdParcelsParcelIdEditIndexRoute =
  AuthenticatedIndividualPaymentFinancialPersonIdParcelsParcelIdEditIndexRouteImport.update(
    {
      id: '/individual-payment/$financialPersonId/parcels/$parcelId/edit/',
      path: '/individual-payment/$financialPersonId/parcels/$parcelId/edit/',
      getParentRoute: () => AuthenticatedRoute,
    } as any,
  )
const AuthenticatedSeriesSerieIdVideosVideoIdLangsCreateIndexRoute =
  AuthenticatedSeriesSerieIdVideosVideoIdLangsCreateIndexRouteImport.update({
    id: '/series/$serieId/videos/$videoId/langs/create/',
    path: '/series/$serieId/videos/$videoId/langs/create/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSeriesSerieIdVideosVideoIdLangsLangIdIndexRoute =
  AuthenticatedSeriesSerieIdVideosVideoIdLangsLangIdIndexRouteImport.update({
    id: '/series/$serieId/videos/$videoId/langs/$langId/',
    path: '/series/$serieId/videos/$videoId/langs/$langId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedExamRevisionExamIdLanguagesLangIdTranslateIndexRoute =
  AuthenticatedExamRevisionExamIdLanguagesLangIdTranslateIndexRouteImport.update(
    {
      id: '/exam/revision/$examId/languages/$langId/translate/',
      path: '/exam/revision/$examId/languages/$langId/translate/',
      getParentRoute: () => AuthenticatedRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/login/': typeof LoginIndexRoute
  '/access-management/': typeof AuthenticatedAccessManagementIndexRoute
  '/banners/': typeof AuthenticatedBannersIndexRoute
  '/class-modules/': typeof AuthenticatedClassModulesIndexRoute
  '/class-planning/': typeof AuthenticatedClassPlanningIndexRoute
  '/enrollments/': typeof AuthenticatedEnrollmentsIndexRoute
  '/exams/': typeof AuthenticatedExamsIndexRoute
  '/individual-payment/': typeof AuthenticatedIndividualPaymentIndexRoute
  '/notification/': typeof AuthenticatedNotificationIndexRoute
  '/persons/': typeof AuthenticatedPersonsIndexRoute
  '/question-library/': typeof AuthenticatedQuestionLibraryIndexRoute
  '/series/': typeof AuthenticatedSeriesIndexRoute
  '/slide-editor/': typeof AuthenticatedSlideEditorIndexRoute
  '/slide-library/': typeof AuthenticatedSlideLibraryIndexRoute
  '/tutor-ai/': typeof AuthenticatedTutorAiIndexRoute
  '/unauthorized/': typeof AuthenticatedUnauthorizedIndexRoute
  '/access-management/$roleId/': typeof AuthenticatedAccessManagementRoleIdIndexRoute
  '/banners/$bannerId/': typeof AuthenticatedBannersBannerIdIndexRoute
  '/banners/create/': typeof AuthenticatedBannersCreateIndexRoute
  '/class-modules/$id/': typeof AuthenticatedClassModulesIdIndexRoute
  '/class-modules/create/': typeof AuthenticatedClassModulesCreateIndexRoute
  '/enrollments/$enrollmentId/': typeof AuthenticatedEnrollmentsEnrollmentIdIndexRoute
  '/enrollments/batch-status/': typeof AuthenticatedEnrollmentsBatchStatusIndexRoute
  '/exam/correction-dashboard/': typeof AuthenticatedExamCorrectionDashboardIndexRoute
  '/exam/grade-config/': typeof AuthenticatedExamGradeConfigIndexRoute
  '/exam/revision/': typeof AuthenticatedExamRevisionIndexRoute
  '/exams/$id/': typeof AuthenticatedExamsIdIndexRoute
  '/exams/create/': typeof AuthenticatedExamsCreateIndexRoute
  '/individual-payment/$financialPersonId/': typeof AuthenticatedIndividualPaymentFinancialPersonIdIndexRoute
  '/individual-payment/create/': typeof AuthenticatedIndividualPaymentCreateIndexRoute
  '/location/cities/': typeof AuthenticatedLocationCitiesIndexRoute
  '/location/countries/': typeof AuthenticatedLocationCountriesIndexRoute
  '/location/states/': typeof AuthenticatedLocationStatesIndexRoute
  '/notification/$id/': typeof AuthenticatedNotificationIdIndexRoute
  '/notification/create/': typeof AuthenticatedNotificationCreateIndexRoute
  '/persons/$id/': typeof AuthenticatedPersonsIdIndexRoute
  '/persons/create/': typeof AuthenticatedPersonsCreateIndexRoute
  '/persons/payments/': typeof AuthenticatedPersonsPaymentsIndexRoute
  '/question-library/$questionId/': typeof AuthenticatedQuestionLibraryQuestionIdIndexRoute
  '/question-library/new/': typeof AuthenticatedQuestionLibraryNewIndexRoute
  '/series/$serieId/': typeof AuthenticatedSeriesSerieIdIndexRoute
  '/series/create/': typeof AuthenticatedSeriesCreateIndexRoute
  '/tutor-ai/classes/': typeof AuthenticatedTutorAiClassesIndexRoute
  '/tutor-ai/config/': typeof AuthenticatedTutorAiConfigIndexRoute
  '/tutor-ai/students/': typeof AuthenticatedTutorAiStudentsIndexRoute
  '/tutor-ai/usage/': typeof AuthenticatedTutorAiUsageIndexRoute
  '/exam/correction/$examPublishId/': typeof AuthenticatedExamCorrectionExamPublishIdIndexRoute
  '/exams/$id/languages/': typeof AuthenticatedExamsIdLanguagesIndexRoute
  '/exams/$id/preview/': typeof AuthenticatedExamsIdPreviewIndexRoute
  '/exams/$id/questions/': typeof AuthenticatedExamsIdQuestionsIndexRoute
  '/individual-payment/$financialPersonId/consolidation/': typeof AuthenticatedIndividualPaymentFinancialPersonIdConsolidationIndexRoute
  '/individual-payment/$financialPersonId/parcels/': typeof AuthenticatedIndividualPaymentFinancialPersonIdParcelsIndexRoute
  '/persons/$id/payments/': typeof AuthenticatedPersonsIdPaymentsIndexRoute
  '/persons/$id/resume/': typeof AuthenticatedPersonsIdResumeIndexRoute
  '/series/$serieId/langs/': typeof AuthenticatedSeriesSerieIdLangsIndexRoute
  '/series/$serieId/videos/': typeof AuthenticatedSeriesSerieIdVideosIndexRoute
  '/tutor-ai/classes/$classStudentId/': typeof AuthenticatedTutorAiClassesClassStudentIdIndexRoute
  '/tutor-ai/students/$personId/': typeof AuthenticatedTutorAiStudentsPersonIdIndexRoute
  '/exam/revision/$examId/languages/': typeof AuthenticatedExamRevisionExamIdLanguagesIndexRoute
  '/exam/revision/$examId/review/': typeof AuthenticatedExamRevisionExamIdReviewIndexRoute
  '/exam/revision/$examId/visualize/': typeof AuthenticatedExamRevisionExamIdVisualizeIndexRoute
  '/individual-payment/$financialPersonId/parcels/create/': typeof AuthenticatedIndividualPaymentFinancialPersonIdParcelsCreateIndexRoute
  '/location/countries/$countryId/langs/': typeof AuthenticatedLocationCountriesCountryIdLangsIndexRoute
  '/persons/payments/plans/$planId/': typeof AuthenticatedPersonsPaymentsPlansPlanIdIndexRoute
  '/series/$serieId/langs/$langId/': typeof AuthenticatedSeriesSerieIdLangsLangIdIndexRoute
  '/series/$serieId/langs/create/': typeof AuthenticatedSeriesSerieIdLangsCreateIndexRoute
  '/series/$serieId/videos/$videoId/': typeof AuthenticatedSeriesSerieIdVideosVideoIdIndexRoute
  '/series/$serieId/videos/create/': typeof AuthenticatedSeriesSerieIdVideosCreateIndexRoute
  '/individual-payment/$financialPersonId/parcels/$parcelId/edit/': typeof AuthenticatedIndividualPaymentFinancialPersonIdParcelsParcelIdEditIndexRoute
  '/persons/payments/plans/$planId/parcels/': typeof AuthenticatedPersonsPaymentsPlansPlanIdParcelsIndexRoute
  '/series/$serieId/videos/$videoId/langs/': typeof AuthenticatedSeriesSerieIdVideosVideoIdLangsIndexRoute
  '/exam/revision/$examId/languages/$langId/translate/': typeof AuthenticatedExamRevisionExamIdLanguagesLangIdTranslateIndexRoute
  '/series/$serieId/videos/$videoId/langs/$langId/': typeof AuthenticatedSeriesSerieIdVideosVideoIdLangsLangIdIndexRoute
  '/series/$serieId/videos/$videoId/langs/create/': typeof AuthenticatedSeriesSerieIdVideosVideoIdLangsCreateIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginIndexRoute
  '/access-management': typeof AuthenticatedAccessManagementIndexRoute
  '/banners': typeof AuthenticatedBannersIndexRoute
  '/class-modules': typeof AuthenticatedClassModulesIndexRoute
  '/class-planning': typeof AuthenticatedClassPlanningIndexRoute
  '/enrollments': typeof AuthenticatedEnrollmentsIndexRoute
  '/exams': typeof AuthenticatedExamsIndexRoute
  '/individual-payment': typeof AuthenticatedIndividualPaymentIndexRoute
  '/notification': typeof AuthenticatedNotificationIndexRoute
  '/persons': typeof AuthenticatedPersonsIndexRoute
  '/question-library': typeof AuthenticatedQuestionLibraryIndexRoute
  '/series': typeof AuthenticatedSeriesIndexRoute
  '/slide-editor': typeof AuthenticatedSlideEditorIndexRoute
  '/slide-library': typeof AuthenticatedSlideLibraryIndexRoute
  '/tutor-ai': typeof AuthenticatedTutorAiIndexRoute
  '/unauthorized': typeof AuthenticatedUnauthorizedIndexRoute
  '/access-management/$roleId': typeof AuthenticatedAccessManagementRoleIdIndexRoute
  '/banners/$bannerId': typeof AuthenticatedBannersBannerIdIndexRoute
  '/banners/create': typeof AuthenticatedBannersCreateIndexRoute
  '/class-modules/$id': typeof AuthenticatedClassModulesIdIndexRoute
  '/class-modules/create': typeof AuthenticatedClassModulesCreateIndexRoute
  '/enrollments/$enrollmentId': typeof AuthenticatedEnrollmentsEnrollmentIdIndexRoute
  '/enrollments/batch-status': typeof AuthenticatedEnrollmentsBatchStatusIndexRoute
  '/exam/correction-dashboard': typeof AuthenticatedExamCorrectionDashboardIndexRoute
  '/exam/grade-config': typeof AuthenticatedExamGradeConfigIndexRoute
  '/exam/revision': typeof AuthenticatedExamRevisionIndexRoute
  '/exams/$id': typeof AuthenticatedExamsIdIndexRoute
  '/exams/create': typeof AuthenticatedExamsCreateIndexRoute
  '/individual-payment/$financialPersonId': typeof AuthenticatedIndividualPaymentFinancialPersonIdIndexRoute
  '/individual-payment/create': typeof AuthenticatedIndividualPaymentCreateIndexRoute
  '/location/cities': typeof AuthenticatedLocationCitiesIndexRoute
  '/location/countries': typeof AuthenticatedLocationCountriesIndexRoute
  '/location/states': typeof AuthenticatedLocationStatesIndexRoute
  '/notification/$id': typeof AuthenticatedNotificationIdIndexRoute
  '/notification/create': typeof AuthenticatedNotificationCreateIndexRoute
  '/persons/$id': typeof AuthenticatedPersonsIdIndexRoute
  '/persons/create': typeof AuthenticatedPersonsCreateIndexRoute
  '/persons/payments': typeof AuthenticatedPersonsPaymentsIndexRoute
  '/question-library/$questionId': typeof AuthenticatedQuestionLibraryQuestionIdIndexRoute
  '/question-library/new': typeof AuthenticatedQuestionLibraryNewIndexRoute
  '/series/$serieId': typeof AuthenticatedSeriesSerieIdIndexRoute
  '/series/create': typeof AuthenticatedSeriesCreateIndexRoute
  '/tutor-ai/classes': typeof AuthenticatedTutorAiClassesIndexRoute
  '/tutor-ai/config': typeof AuthenticatedTutorAiConfigIndexRoute
  '/tutor-ai/students': typeof AuthenticatedTutorAiStudentsIndexRoute
  '/tutor-ai/usage': typeof AuthenticatedTutorAiUsageIndexRoute
  '/exam/correction/$examPublishId': typeof AuthenticatedExamCorrectionExamPublishIdIndexRoute
  '/exams/$id/languages': typeof AuthenticatedExamsIdLanguagesIndexRoute
  '/exams/$id/preview': typeof AuthenticatedExamsIdPreviewIndexRoute
  '/exams/$id/questions': typeof AuthenticatedExamsIdQuestionsIndexRoute
  '/individual-payment/$financialPersonId/consolidation': typeof AuthenticatedIndividualPaymentFinancialPersonIdConsolidationIndexRoute
  '/individual-payment/$financialPersonId/parcels': typeof AuthenticatedIndividualPaymentFinancialPersonIdParcelsIndexRoute
  '/persons/$id/payments': typeof AuthenticatedPersonsIdPaymentsIndexRoute
  '/persons/$id/resume': typeof AuthenticatedPersonsIdResumeIndexRoute
  '/series/$serieId/langs': typeof AuthenticatedSeriesSerieIdLangsIndexRoute
  '/series/$serieId/videos': typeof AuthenticatedSeriesSerieIdVideosIndexRoute
  '/tutor-ai/classes/$classStudentId': typeof AuthenticatedTutorAiClassesClassStudentIdIndexRoute
  '/tutor-ai/students/$personId': typeof AuthenticatedTutorAiStudentsPersonIdIndexRoute
  '/exam/revision/$examId/languages': typeof AuthenticatedExamRevisionExamIdLanguagesIndexRoute
  '/exam/revision/$examId/review': typeof AuthenticatedExamRevisionExamIdReviewIndexRoute
  '/exam/revision/$examId/visualize': typeof AuthenticatedExamRevisionExamIdVisualizeIndexRoute
  '/individual-payment/$financialPersonId/parcels/create': typeof AuthenticatedIndividualPaymentFinancialPersonIdParcelsCreateIndexRoute
  '/location/countries/$countryId/langs': typeof AuthenticatedLocationCountriesCountryIdLangsIndexRoute
  '/persons/payments/plans/$planId': typeof AuthenticatedPersonsPaymentsPlansPlanIdIndexRoute
  '/series/$serieId/langs/$langId': typeof AuthenticatedSeriesSerieIdLangsLangIdIndexRoute
  '/series/$serieId/langs/create': typeof AuthenticatedSeriesSerieIdLangsCreateIndexRoute
  '/series/$serieId/videos/$videoId': typeof AuthenticatedSeriesSerieIdVideosVideoIdIndexRoute
  '/series/$serieId/videos/create': typeof AuthenticatedSeriesSerieIdVideosCreateIndexRoute
  '/individual-payment/$financialPersonId/parcels/$parcelId/edit': typeof AuthenticatedIndividualPaymentFinancialPersonIdParcelsParcelIdEditIndexRoute
  '/persons/payments/plans/$planId/parcels': typeof AuthenticatedPersonsPaymentsPlansPlanIdParcelsIndexRoute
  '/series/$serieId/videos/$videoId/langs': typeof AuthenticatedSeriesSerieIdVideosVideoIdLangsIndexRoute
  '/exam/revision/$examId/languages/$langId/translate': typeof AuthenticatedExamRevisionExamIdLanguagesLangIdTranslateIndexRoute
  '/series/$serieId/videos/$videoId/langs/$langId': typeof AuthenticatedSeriesSerieIdVideosVideoIdLangsLangIdIndexRoute
  '/series/$serieId/videos/$videoId/langs/create': typeof AuthenticatedSeriesSerieIdVideosVideoIdLangsCreateIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/login/': typeof LoginIndexRoute
  '/_authenticated/access-management/': typeof AuthenticatedAccessManagementIndexRoute
  '/_authenticated/banners/': typeof AuthenticatedBannersIndexRoute
  '/_authenticated/class-modules/': typeof AuthenticatedClassModulesIndexRoute
  '/_authenticated/class-planning/': typeof AuthenticatedClassPlanningIndexRoute
  '/_authenticated/enrollments/': typeof AuthenticatedEnrollmentsIndexRoute
  '/_authenticated/exams/': typeof AuthenticatedExamsIndexRoute
  '/_authenticated/individual-payment/': typeof AuthenticatedIndividualPaymentIndexRoute
  '/_authenticated/notification/': typeof AuthenticatedNotificationIndexRoute
  '/_authenticated/persons/': typeof AuthenticatedPersonsIndexRoute
  '/_authenticated/question-library/': typeof AuthenticatedQuestionLibraryIndexRoute
  '/_authenticated/series/': typeof AuthenticatedSeriesIndexRoute
  '/_authenticated/slide-editor/': typeof AuthenticatedSlideEditorIndexRoute
  '/_authenticated/slide-library/': typeof AuthenticatedSlideLibraryIndexRoute
  '/_authenticated/tutor-ai/': typeof AuthenticatedTutorAiIndexRoute
  '/_authenticated/unauthorized/': typeof AuthenticatedUnauthorizedIndexRoute
  '/_authenticated/access-management/$roleId/': typeof AuthenticatedAccessManagementRoleIdIndexRoute
  '/_authenticated/banners/$bannerId/': typeof AuthenticatedBannersBannerIdIndexRoute
  '/_authenticated/banners/create/': typeof AuthenticatedBannersCreateIndexRoute
  '/_authenticated/class-modules/$id/': typeof AuthenticatedClassModulesIdIndexRoute
  '/_authenticated/class-modules/create/': typeof AuthenticatedClassModulesCreateIndexRoute
  '/_authenticated/enrollments/$enrollmentId/': typeof AuthenticatedEnrollmentsEnrollmentIdIndexRoute
  '/_authenticated/enrollments/batch-status/': typeof AuthenticatedEnrollmentsBatchStatusIndexRoute
  '/_authenticated/exam/correction-dashboard/': typeof AuthenticatedExamCorrectionDashboardIndexRoute
  '/_authenticated/exam/grade-config/': typeof AuthenticatedExamGradeConfigIndexRoute
  '/_authenticated/exam/revision/': typeof AuthenticatedExamRevisionIndexRoute
  '/_authenticated/exams/$id/': typeof AuthenticatedExamsIdIndexRoute
  '/_authenticated/exams/create/': typeof AuthenticatedExamsCreateIndexRoute
  '/_authenticated/individual-payment/$financialPersonId/': typeof AuthenticatedIndividualPaymentFinancialPersonIdIndexRoute
  '/_authenticated/individual-payment/create/': typeof AuthenticatedIndividualPaymentCreateIndexRoute
  '/_authenticated/location/cities/': typeof AuthenticatedLocationCitiesIndexRoute
  '/_authenticated/location/countries/': typeof AuthenticatedLocationCountriesIndexRoute
  '/_authenticated/location/states/': typeof AuthenticatedLocationStatesIndexRoute
  '/_authenticated/notification/$id/': typeof AuthenticatedNotificationIdIndexRoute
  '/_authenticated/notification/create/': typeof AuthenticatedNotificationCreateIndexRoute
  '/_authenticated/persons/$id/': typeof AuthenticatedPersonsIdIndexRoute
  '/_authenticated/persons/create/': typeof AuthenticatedPersonsCreateIndexRoute
  '/_authenticated/persons/payments/': typeof AuthenticatedPersonsPaymentsIndexRoute
  '/_authenticated/question-library/$questionId/': typeof AuthenticatedQuestionLibraryQuestionIdIndexRoute
  '/_authenticated/question-library/new/': typeof AuthenticatedQuestionLibraryNewIndexRoute
  '/_authenticated/series/$serieId/': typeof AuthenticatedSeriesSerieIdIndexRoute
  '/_authenticated/series/create/': typeof AuthenticatedSeriesCreateIndexRoute
  '/_authenticated/tutor-ai/classes/': typeof AuthenticatedTutorAiClassesIndexRoute
  '/_authenticated/tutor-ai/config/': typeof AuthenticatedTutorAiConfigIndexRoute
  '/_authenticated/tutor-ai/students/': typeof AuthenticatedTutorAiStudentsIndexRoute
  '/_authenticated/tutor-ai/usage/': typeof AuthenticatedTutorAiUsageIndexRoute
  '/_authenticated/exam/correction/$examPublishId/': typeof AuthenticatedExamCorrectionExamPublishIdIndexRoute
  '/_authenticated/exams/$id/languages/': typeof AuthenticatedExamsIdLanguagesIndexRoute
  '/_authenticated/exams/$id/preview/': typeof AuthenticatedExamsIdPreviewIndexRoute
  '/_authenticated/exams/$id/questions/': typeof AuthenticatedExamsIdQuestionsIndexRoute
  '/_authenticated/individual-payment/$financialPersonId/consolidation/': typeof AuthenticatedIndividualPaymentFinancialPersonIdConsolidationIndexRoute
  '/_authenticated/individual-payment/$financialPersonId/parcels/': typeof AuthenticatedIndividualPaymentFinancialPersonIdParcelsIndexRoute
  '/_authenticated/persons/$id/payments/': typeof AuthenticatedPersonsIdPaymentsIndexRoute
  '/_authenticated/persons/$id/resume/': typeof AuthenticatedPersonsIdResumeIndexRoute
  '/_authenticated/series/$serieId/langs/': typeof AuthenticatedSeriesSerieIdLangsIndexRoute
  '/_authenticated/series/$serieId/videos/': typeof AuthenticatedSeriesSerieIdVideosIndexRoute
  '/_authenticated/tutor-ai/classes/$classStudentId/': typeof AuthenticatedTutorAiClassesClassStudentIdIndexRoute
  '/_authenticated/tutor-ai/students/$personId/': typeof AuthenticatedTutorAiStudentsPersonIdIndexRoute
  '/_authenticated/exam/revision/$examId/languages/': typeof AuthenticatedExamRevisionExamIdLanguagesIndexRoute
  '/_authenticated/exam/revision/$examId/review/': typeof AuthenticatedExamRevisionExamIdReviewIndexRoute
  '/_authenticated/exam/revision/$examId/visualize/': typeof AuthenticatedExamRevisionExamIdVisualizeIndexRoute
  '/_authenticated/individual-payment/$financialPersonId/parcels/create/': typeof AuthenticatedIndividualPaymentFinancialPersonIdParcelsCreateIndexRoute
  '/_authenticated/location/countries/$countryId/langs/': typeof AuthenticatedLocationCountriesCountryIdLangsIndexRoute
  '/_authenticated/persons/payments/plans/$planId/': typeof AuthenticatedPersonsPaymentsPlansPlanIdIndexRoute
  '/_authenticated/series/$serieId/langs/$langId/': typeof AuthenticatedSeriesSerieIdLangsLangIdIndexRoute
  '/_authenticated/series/$serieId/langs/create/': typeof AuthenticatedSeriesSerieIdLangsCreateIndexRoute
  '/_authenticated/series/$serieId/videos/$videoId/': typeof AuthenticatedSeriesSerieIdVideosVideoIdIndexRoute
  '/_authenticated/series/$serieId/videos/create/': typeof AuthenticatedSeriesSerieIdVideosCreateIndexRoute
  '/_authenticated/individual-payment/$financialPersonId/parcels/$parcelId/edit/': typeof AuthenticatedIndividualPaymentFinancialPersonIdParcelsParcelIdEditIndexRoute
  '/_authenticated/persons/payments/plans/$planId/parcels/': typeof AuthenticatedPersonsPaymentsPlansPlanIdParcelsIndexRoute
  '/_authenticated/series/$serieId/videos/$videoId/langs/': typeof AuthenticatedSeriesSerieIdVideosVideoIdLangsIndexRoute
  '/_authenticated/exam/revision/$examId/languages/$langId/translate/': typeof AuthenticatedExamRevisionExamIdLanguagesLangIdTranslateIndexRoute
  '/_authenticated/series/$serieId/videos/$videoId/langs/$langId/': typeof AuthenticatedSeriesSerieIdVideosVideoIdLangsLangIdIndexRoute
  '/_authenticated/series/$serieId/videos/$videoId/langs/create/': typeof AuthenticatedSeriesSerieIdVideosVideoIdLangsCreateIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login/'
    | '/access-management/'
    | '/banners/'
    | '/class-modules/'
    | '/class-planning/'
    | '/enrollments/'
    | '/exams/'
    | '/individual-payment/'
    | '/notification/'
    | '/persons/'
    | '/question-library/'
    | '/series/'
    | '/slide-editor/'
    | '/slide-library/'
    | '/tutor-ai/'
    | '/unauthorized/'
    | '/access-management/$roleId/'
    | '/banners/$bannerId/'
    | '/banners/create/'
    | '/class-modules/$id/'
    | '/class-modules/create/'
    | '/enrollments/$enrollmentId/'
    | '/enrollments/batch-status/'
    | '/exam/correction-dashboard/'
    | '/exam/grade-config/'
    | '/exam/revision/'
    | '/exams/$id/'
    | '/exams/create/'
    | '/individual-payment/$financialPersonId/'
    | '/individual-payment/create/'
    | '/location/cities/'
    | '/location/countries/'
    | '/location/states/'
    | '/notification/$id/'
    | '/notification/create/'
    | '/persons/$id/'
    | '/persons/create/'
    | '/persons/payments/'
    | '/question-library/$questionId/'
    | '/question-library/new/'
    | '/series/$serieId/'
    | '/series/create/'
    | '/tutor-ai/classes/'
    | '/tutor-ai/config/'
    | '/tutor-ai/students/'
    | '/tutor-ai/usage/'
    | '/exam/correction/$examPublishId/'
    | '/exams/$id/languages/'
    | '/exams/$id/preview/'
    | '/exams/$id/questions/'
    | '/individual-payment/$financialPersonId/consolidation/'
    | '/individual-payment/$financialPersonId/parcels/'
    | '/persons/$id/payments/'
    | '/persons/$id/resume/'
    | '/series/$serieId/langs/'
    | '/series/$serieId/videos/'
    | '/tutor-ai/classes/$classStudentId/'
    | '/tutor-ai/students/$personId/'
    | '/exam/revision/$examId/languages/'
    | '/exam/revision/$examId/review/'
    | '/exam/revision/$examId/visualize/'
    | '/individual-payment/$financialPersonId/parcels/create/'
    | '/location/countries/$countryId/langs/'
    | '/persons/payments/plans/$planId/'
    | '/series/$serieId/langs/$langId/'
    | '/series/$serieId/langs/create/'
    | '/series/$serieId/videos/$videoId/'
    | '/series/$serieId/videos/create/'
    | '/individual-payment/$financialPersonId/parcels/$parcelId/edit/'
    | '/persons/payments/plans/$planId/parcels/'
    | '/series/$serieId/videos/$videoId/langs/'
    | '/exam/revision/$examId/languages/$langId/translate/'
    | '/series/$serieId/videos/$videoId/langs/$langId/'
    | '/series/$serieId/videos/$videoId/langs/create/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/access-management'
    | '/banners'
    | '/class-modules'
    | '/class-planning'
    | '/enrollments'
    | '/exams'
    | '/individual-payment'
    | '/notification'
    | '/persons'
    | '/question-library'
    | '/series'
    | '/slide-editor'
    | '/slide-library'
    | '/tutor-ai'
    | '/unauthorized'
    | '/access-management/$roleId'
    | '/banners/$bannerId'
    | '/banners/create'
    | '/class-modules/$id'
    | '/class-modules/create'
    | '/enrollments/$enrollmentId'
    | '/enrollments/batch-status'
    | '/exam/correction-dashboard'
    | '/exam/grade-config'
    | '/exam/revision'
    | '/exams/$id'
    | '/exams/create'
    | '/individual-payment/$financialPersonId'
    | '/individual-payment/create'
    | '/location/cities'
    | '/location/countries'
    | '/location/states'
    | '/notification/$id'
    | '/notification/create'
    | '/persons/$id'
    | '/persons/create'
    | '/persons/payments'
    | '/question-library/$questionId'
    | '/question-library/new'
    | '/series/$serieId'
    | '/series/create'
    | '/tutor-ai/classes'
    | '/tutor-ai/config'
    | '/tutor-ai/students'
    | '/tutor-ai/usage'
    | '/exam/correction/$examPublishId'
    | '/exams/$id/languages'
    | '/exams/$id/preview'
    | '/exams/$id/questions'
    | '/individual-payment/$financialPersonId/consolidation'
    | '/individual-payment/$financialPersonId/parcels'
    | '/persons/$id/payments'
    | '/persons/$id/resume'
    | '/series/$serieId/langs'
    | '/series/$serieId/videos'
    | '/tutor-ai/classes/$classStudentId'
    | '/tutor-ai/students/$personId'
    | '/exam/revision/$examId/languages'
    | '/exam/revision/$examId/review'
    | '/exam/revision/$examId/visualize'
    | '/individual-payment/$financialPersonId/parcels/create'
    | '/location/countries/$countryId/langs'
    | '/persons/payments/plans/$planId'
    | '/series/$serieId/langs/$langId'
    | '/series/$serieId/langs/create'
    | '/series/$serieId/videos/$videoId'
    | '/series/$serieId/videos/create'
    | '/individual-payment/$financialPersonId/parcels/$parcelId/edit'
    | '/persons/payments/plans/$planId/parcels'
    | '/series/$serieId/videos/$videoId/langs'
    | '/exam/revision/$examId/languages/$langId/translate'
    | '/series/$serieId/videos/$videoId/langs/$langId'
    | '/series/$serieId/videos/$videoId/langs/create'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_authenticated/'
    | '/login/'
    | '/_authenticated/access-management/'
    | '/_authenticated/banners/'
    | '/_authenticated/class-modules/'
    | '/_authenticated/class-planning/'
    | '/_authenticated/enrollments/'
    | '/_authenticated/exams/'
    | '/_authenticated/individual-payment/'
    | '/_authenticated/notification/'
    | '/_authenticated/persons/'
    | '/_authenticated/question-library/'
    | '/_authenticated/series/'
    | '/_authenticated/slide-editor/'
    | '/_authenticated/slide-library/'
    | '/_authenticated/tutor-ai/'
    | '/_authenticated/unauthorized/'
    | '/_authenticated/access-management/$roleId/'
    | '/_authenticated/banners/$bannerId/'
    | '/_authenticated/banners/create/'
    | '/_authenticated/class-modules/$id/'
    | '/_authenticated/class-modules/create/'
    | '/_authenticated/enrollments/$enrollmentId/'
    | '/_authenticated/enrollments/batch-status/'
    | '/_authenticated/exam/correction-dashboard/'
    | '/_authenticated/exam/grade-config/'
    | '/_authenticated/exam/revision/'
    | '/_authenticated/exams/$id/'
    | '/_authenticated/exams/create/'
    | '/_authenticated/individual-payment/$financialPersonId/'
    | '/_authenticated/individual-payment/create/'
    | '/_authenticated/location/cities/'
    | '/_authenticated/location/countries/'
    | '/_authenticated/location/states/'
    | '/_authenticated/notification/$id/'
    | '/_authenticated/notification/create/'
    | '/_authenticated/persons/$id/'
    | '/_authenticated/persons/create/'
    | '/_authenticated/persons/payments/'
    | '/_authenticated/question-library/$questionId/'
    | '/_authenticated/question-library/new/'
    | '/_authenticated/series/$serieId/'
    | '/_authenticated/series/create/'
    | '/_authenticated/tutor-ai/classes/'
    | '/_authenticated/tutor-ai/config/'
    | '/_authenticated/tutor-ai/students/'
    | '/_authenticated/tutor-ai/usage/'
    | '/_authenticated/exam/correction/$examPublishId/'
    | '/_authenticated/exams/$id/languages/'
    | '/_authenticated/exams/$id/preview/'
    | '/_authenticated/exams/$id/questions/'
    | '/_authenticated/individual-payment/$financialPersonId/consolidation/'
    | '/_authenticated/individual-payment/$financialPersonId/parcels/'
    | '/_authenticated/persons/$id/payments/'
    | '/_authenticated/persons/$id/resume/'
    | '/_authenticated/series/$serieId/langs/'
    | '/_authenticated/series/$serieId/videos/'
    | '/_authenticated/tutor-ai/classes/$classStudentId/'
    | '/_authenticated/tutor-ai/students/$personId/'
    | '/_authenticated/exam/revision/$examId/languages/'
    | '/_authenticated/exam/revision/$examId/review/'
    | '/_authenticated/exam/revision/$examId/visualize/'
    | '/_authenticated/individual-payment/$financialPersonId/parcels/create/'
    | '/_authenticated/location/countries/$countryId/langs/'
    | '/_authenticated/persons/payments/plans/$planId/'
    | '/_authenticated/series/$serieId/langs/$langId/'
    | '/_authenticated/series/$serieId/langs/create/'
    | '/_authenticated/series/$serieId/videos/$videoId/'
    | '/_authenticated/series/$serieId/videos/create/'
    | '/_authenticated/individual-payment/$financialPersonId/parcels/$parcelId/edit/'
    | '/_authenticated/persons/payments/plans/$planId/parcels/'
    | '/_authenticated/series/$serieId/videos/$videoId/langs/'
    | '/_authenticated/exam/revision/$examId/languages/$langId/translate/'
    | '/_authenticated/series/$serieId/videos/$videoId/langs/$langId/'
    | '/_authenticated/series/$serieId/videos/$videoId/langs/create/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginIndexRoute: typeof LoginIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/unauthorized/': {
      id: '/_authenticated/unauthorized/'
      path: '/unauthorized'
      fullPath: '/unauthorized/'
      preLoaderRoute: typeof AuthenticatedUnauthorizedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tutor-ai/': {
      id: '/_authenticated/tutor-ai/'
      path: '/tutor-ai'
      fullPath: '/tutor-ai/'
      preLoaderRoute: typeof AuthenticatedTutorAiIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/slide-library/': {
      id: '/_authenticated/slide-library/'
      path: '/slide-library'
      fullPath: '/slide-library/'
      preLoaderRoute: typeof AuthenticatedSlideLibraryIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/slide-editor/': {
      id: '/_authenticated/slide-editor/'
      path: '/slide-editor'
      fullPath: '/slide-editor/'
      preLoaderRoute: typeof AuthenticatedSlideEditorIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/series/': {
      id: '/_authenticated/series/'
      path: '/series'
      fullPath: '/series/'
      preLoaderRoute: typeof AuthenticatedSeriesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/question-library/': {
      id: '/_authenticated/question-library/'
      path: '/question-library'
      fullPath: '/question-library/'
      preLoaderRoute: typeof AuthenticatedQuestionLibraryIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/persons/': {
      id: '/_authenticated/persons/'
      path: '/persons'
      fullPath: '/persons/'
      preLoaderRoute: typeof AuthenticatedPersonsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notification/': {
      id: '/_authenticated/notification/'
      path: '/notification'
      fullPath: '/notification/'
      preLoaderRoute: typeof AuthenticatedNotificationIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/individual-payment/': {
      id: '/_authenticated/individual-payment/'
      path: '/individual-payment'
      fullPath: '/individual-payment/'
      preLoaderRoute: typeof AuthenticatedIndividualPaymentIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/exams/': {
      id: '/_authenticated/exams/'
      path: '/exams'
      fullPath: '/exams/'
      preLoaderRoute: typeof AuthenticatedExamsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/enrollments/': {
      id: '/_authenticated/enrollments/'
      path: '/enrollments'
      fullPath: '/enrollments/'
      preLoaderRoute: typeof AuthenticatedEnrollmentsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/class-planning/': {
      id: '/_authenticated/class-planning/'
      path: '/class-planning'
      fullPath: '/class-planning/'
      preLoaderRoute: typeof AuthenticatedClassPlanningIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/class-modules/': {
      id: '/_authenticated/class-modules/'
      path: '/class-modules'
      fullPath: '/class-modules/'
      preLoaderRoute: typeof AuthenticatedClassModulesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/banners/': {
      id: '/_authenticated/banners/'
      path: '/banners'
      fullPath: '/banners/'
      preLoaderRoute: typeof AuthenticatedBannersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/access-management/': {
      id: '/_authenticated/access-management/'
      path: '/access-management'
      fullPath: '/access-management/'
      preLoaderRoute: typeof AuthenticatedAccessManagementIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tutor-ai/usage/': {
      id: '/_authenticated/tutor-ai/usage/'
      path: '/tutor-ai/usage'
      fullPath: '/tutor-ai/usage/'
      preLoaderRoute: typeof AuthenticatedTutorAiUsageIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tutor-ai/students/': {
      id: '/_authenticated/tutor-ai/students/'
      path: '/tutor-ai/students'
      fullPath: '/tutor-ai/students/'
      preLoaderRoute: typeof AuthenticatedTutorAiStudentsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tutor-ai/config/': {
      id: '/_authenticated/tutor-ai/config/'
      path: '/tutor-ai/config'
      fullPath: '/tutor-ai/config/'
      preLoaderRoute: typeof AuthenticatedTutorAiConfigIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tutor-ai/classes/': {
      id: '/_authenticated/tutor-ai/classes/'
      path: '/tutor-ai/classes'
      fullPath: '/tutor-ai/classes/'
      preLoaderRoute: typeof AuthenticatedTutorAiClassesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/series/create/': {
      id: '/_authenticated/series/create/'
      path: '/series/create'
      fullPath: '/series/create/'
      preLoaderRoute: typeof AuthenticatedSeriesCreateIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/series/$serieId/': {
      id: '/_authenticated/series/$serieId/'
      path: '/series/$serieId'
      fullPath: '/series/$serieId/'
      preLoaderRoute: typeof AuthenticatedSeriesSerieIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/question-library/new/': {
      id: '/_authenticated/question-library/new/'
      path: '/question-library/new'
      fullPath: '/question-library/new/'
      preLoaderRoute: typeof AuthenticatedQuestionLibraryNewIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/question-library/$questionId/': {
      id: '/_authenticated/question-library/$questionId/'
      path: '/question-library/$questionId'
      fullPath: '/question-library/$questionId/'
      preLoaderRoute: typeof AuthenticatedQuestionLibraryQuestionIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/persons/payments/': {
      id: '/_authenticated/persons/payments/'
      path: '/persons/payments'
      fullPath: '/persons/payments/'
      preLoaderRoute: typeof AuthenticatedPersonsPaymentsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/persons/create/': {
      id: '/_authenticated/persons/create/'
      path: '/persons/create'
      fullPath: '/persons/create/'
      preLoaderRoute: typeof AuthenticatedPersonsCreateIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/persons/$id/': {
      id: '/_authenticated/persons/$id/'
      path: '/persons/$id'
      fullPath: '/persons/$id/'
      preLoaderRoute: typeof AuthenticatedPersonsIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notification/create/': {
      id: '/_authenticated/notification/create/'
      path: '/notification/create'
      fullPath: '/notification/create/'
      preLoaderRoute: typeof AuthenticatedNotificationCreateIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notification/$id/': {
      id: '/_authenticated/notification/$id/'
      path: '/notification/$id'
      fullPath: '/notification/$id/'
      preLoaderRoute: typeof AuthenticatedNotificationIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/location/states/': {
      id: '/_authenticated/location/states/'
      path: '/location/states'
      fullPath: '/location/states/'
      preLoaderRoute: typeof AuthenticatedLocationStatesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/location/countries/': {
      id: '/_authenticated/location/countries/'
      path: '/location/countries'
      fullPath: '/location/countries/'
      preLoaderRoute: typeof AuthenticatedLocationCountriesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/location/cities/': {
      id: '/_authenticated/location/cities/'
      path: '/location/cities'
      fullPath: '/location/cities/'
      preLoaderRoute: typeof AuthenticatedLocationCitiesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/individual-payment/create/': {
      id: '/_authenticated/individual-payment/create/'
      path: '/individual-payment/create'
      fullPath: '/individual-payment/create/'
      preLoaderRoute: typeof AuthenticatedIndividualPaymentCreateIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/individual-payment/$financialPersonId/': {
      id: '/_authenticated/individual-payment/$financialPersonId/'
      path: '/individual-payment/$financialPersonId'
      fullPath: '/individual-payment/$financialPersonId/'
      preLoaderRoute: typeof AuthenticatedIndividualPaymentFinancialPersonIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/exams/create/': {
      id: '/_authenticated/exams/create/'
      path: '/exams/create'
      fullPath: '/exams/create/'
      preLoaderRoute: typeof AuthenticatedExamsCreateIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/exams/$id/': {
      id: '/_authenticated/exams/$id/'
      path: '/exams/$id'
      fullPath: '/exams/$id/'
      preLoaderRoute: typeof AuthenticatedExamsIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/exam/revision/': {
      id: '/_authenticated/exam/revision/'
      path: '/exam/revision'
      fullPath: '/exam/revision/'
      preLoaderRoute: typeof AuthenticatedExamRevisionIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/exam/grade-config/': {
      id: '/_authenticated/exam/grade-config/'
      path: '/exam/grade-config'
      fullPath: '/exam/grade-config/'
      preLoaderRoute: typeof AuthenticatedExamGradeConfigIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/exam/correction-dashboard/': {
      id: '/_authenticated/exam/correction-dashboard/'
      path: '/exam/correction-dashboard'
      fullPath: '/exam/correction-dashboard/'
      preLoaderRoute: typeof AuthenticatedExamCorrectionDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/enrollments/batch-status/': {
      id: '/_authenticated/enrollments/batch-status/'
      path: '/enrollments/batch-status'
      fullPath: '/enrollments/batch-status/'
      preLoaderRoute: typeof AuthenticatedEnrollmentsBatchStatusIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/enrollments/$enrollmentId/': {
      id: '/_authenticated/enrollments/$enrollmentId/'
      path: '/enrollments/$enrollmentId'
      fullPath: '/enrollments/$enrollmentId/'
      preLoaderRoute: typeof AuthenticatedEnrollmentsEnrollmentIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/class-modules/create/': {
      id: '/_authenticated/class-modules/create/'
      path: '/class-modules/create'
      fullPath: '/class-modules/create/'
      preLoaderRoute: typeof AuthenticatedClassModulesCreateIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/class-modules/$id/': {
      id: '/_authenticated/class-modules/$id/'
      path: '/class-modules/$id'
      fullPath: '/class-modules/$id/'
      preLoaderRoute: typeof AuthenticatedClassModulesIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/banners/create/': {
      id: '/_authenticated/banners/create/'
      path: '/banners/create'
      fullPath: '/banners/create/'
      preLoaderRoute: typeof AuthenticatedBannersCreateIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/banners/$bannerId/': {
      id: '/_authenticated/banners/$bannerId/'
      path: '/banners/$bannerId'
      fullPath: '/banners/$bannerId/'
      preLoaderRoute: typeof AuthenticatedBannersBannerIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/access-management/$roleId/': {
      id: '/_authenticated/access-management/$roleId/'
      path: '/access-management/$roleId'
      fullPath: '/access-management/$roleId/'
      preLoaderRoute: typeof AuthenticatedAccessManagementRoleIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tutor-ai/students/$personId/': {
      id: '/_authenticated/tutor-ai/students/$personId/'
      path: '/tutor-ai/students/$personId'
      fullPath: '/tutor-ai/students/$personId/'
      preLoaderRoute: typeof AuthenticatedTutorAiStudentsPersonIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tutor-ai/classes/$classStudentId/': {
      id: '/_authenticated/tutor-ai/classes/$classStudentId/'
      path: '/tutor-ai/classes/$classStudentId'
      fullPath: '/tutor-ai/classes/$classStudentId/'
      preLoaderRoute: typeof AuthenticatedTutorAiClassesClassStudentIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/series/$serieId/videos/': {
      id: '/_authenticated/series/$serieId/videos/'
      path: '/series/$serieId/videos'
      fullPath: '/series/$serieId/videos/'
      preLoaderRoute: typeof AuthenticatedSeriesSerieIdVideosIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/series/$serieId/langs/': {
      id: '/_authenticated/series/$serieId/langs/'
      path: '/series/$serieId/langs'
      fullPath: '/series/$serieId/langs/'
      preLoaderRoute: typeof AuthenticatedSeriesSerieIdLangsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/persons/$id/resume/': {
      id: '/_authenticated/persons/$id/resume/'
      path: '/persons/$id/resume'
      fullPath: '/persons/$id/resume/'
      preLoaderRoute: typeof AuthenticatedPersonsIdResumeIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/persons/$id/payments/': {
      id: '/_authenticated/persons/$id/payments/'
      path: '/persons/$id/payments'
      fullPath: '/persons/$id/payments/'
      preLoaderRoute: typeof AuthenticatedPersonsIdPaymentsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/individual-payment/$financialPersonId/parcels/': {
      id: '/_authenticated/individual-payment/$financialPersonId/parcels/'
      path: '/individual-payment/$financialPersonId/parcels'
      fullPath: '/individual-payment/$financialPersonId/parcels/'
      preLoaderRoute: typeof AuthenticatedIndividualPaymentFinancialPersonIdParcelsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/individual-payment/$financialPersonId/consolidation/': {
      id: '/_authenticated/individual-payment/$financialPersonId/consolidation/'
      path: '/individual-payment/$financialPersonId/consolidation'
      fullPath: '/individual-payment/$financialPersonId/consolidation/'
      preLoaderRoute: typeof AuthenticatedIndividualPaymentFinancialPersonIdConsolidationIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/exams/$id/questions/': {
      id: '/_authenticated/exams/$id/questions/'
      path: '/exams/$id/questions'
      fullPath: '/exams/$id/questions/'
      preLoaderRoute: typeof AuthenticatedExamsIdQuestionsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/exams/$id/preview/': {
      id: '/_authenticated/exams/$id/preview/'
      path: '/exams/$id/preview'
      fullPath: '/exams/$id/preview/'
      preLoaderRoute: typeof AuthenticatedExamsIdPreviewIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/exams/$id/languages/': {
      id: '/_authenticated/exams/$id/languages/'
      path: '/exams/$id/languages'
      fullPath: '/exams/$id/languages/'
      preLoaderRoute: typeof AuthenticatedExamsIdLanguagesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/exam/correction/$examPublishId/': {
      id: '/_authenticated/exam/correction/$examPublishId/'
      path: '/exam/correction/$examPublishId'
      fullPath: '/exam/correction/$examPublishId/'
      preLoaderRoute: typeof AuthenticatedExamCorrectionExamPublishIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/series/$serieId/videos/create/': {
      id: '/_authenticated/series/$serieId/videos/create/'
      path: '/series/$serieId/videos/create'
      fullPath: '/series/$serieId/videos/create/'
      preLoaderRoute: typeof AuthenticatedSeriesSerieIdVideosCreateIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/series/$serieId/videos/$videoId/': {
      id: '/_authenticated/series/$serieId/videos/$videoId/'
      path: '/series/$serieId/videos/$videoId'
      fullPath: '/series/$serieId/videos/$videoId/'
      preLoaderRoute: typeof AuthenticatedSeriesSerieIdVideosVideoIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/series/$serieId/langs/create/': {
      id: '/_authenticated/series/$serieId/langs/create/'
      path: '/series/$serieId/langs/create'
      fullPath: '/series/$serieId/langs/create/'
      preLoaderRoute: typeof AuthenticatedSeriesSerieIdLangsCreateIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/series/$serieId/langs/$langId/': {
      id: '/_authenticated/series/$serieId/langs/$langId/'
      path: '/series/$serieId/langs/$langId'
      fullPath: '/series/$serieId/langs/$langId/'
      preLoaderRoute: typeof AuthenticatedSeriesSerieIdLangsLangIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/persons/payments/plans/$planId/': {
      id: '/_authenticated/persons/payments/plans/$planId/'
      path: '/persons/payments/plans/$planId'
      fullPath: '/persons/payments/plans/$planId/'
      preLoaderRoute: typeof AuthenticatedPersonsPaymentsPlansPlanIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/location/countries/$countryId/langs/': {
      id: '/_authenticated/location/countries/$countryId/langs/'
      path: '/location/countries/$countryId/langs'
      fullPath: '/location/countries/$countryId/langs/'
      preLoaderRoute: typeof AuthenticatedLocationCountriesCountryIdLangsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/individual-payment/$financialPersonId/parcels/create/': {
      id: '/_authenticated/individual-payment/$financialPersonId/parcels/create/'
      path: '/individual-payment/$financialPersonId/parcels/create'
      fullPath: '/individual-payment/$financialPersonId/parcels/create/'
      preLoaderRoute: typeof AuthenticatedIndividualPaymentFinancialPersonIdParcelsCreateIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/exam/revision/$examId/visualize/': {
      id: '/_authenticated/exam/revision/$examId/visualize/'
      path: '/exam/revision/$examId/visualize'
      fullPath: '/exam/revision/$examId/visualize/'
      preLoaderRoute: typeof AuthenticatedExamRevisionExamIdVisualizeIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/exam/revision/$examId/review/': {
      id: '/_authenticated/exam/revision/$examId/review/'
      path: '/exam/revision/$examId/review'
      fullPath: '/exam/revision/$examId/review/'
      preLoaderRoute: typeof AuthenticatedExamRevisionExamIdReviewIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/exam/revision/$examId/languages/': {
      id: '/_authenticated/exam/revision/$examId/languages/'
      path: '/exam/revision/$examId/languages'
      fullPath: '/exam/revision/$examId/languages/'
      preLoaderRoute: typeof AuthenticatedExamRevisionExamIdLanguagesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/series/$serieId/videos/$videoId/langs/': {
      id: '/_authenticated/series/$serieId/videos/$videoId/langs/'
      path: '/series/$serieId/videos/$videoId/langs'
      fullPath: '/series/$serieId/videos/$videoId/langs/'
      preLoaderRoute: typeof AuthenticatedSeriesSerieIdVideosVideoIdLangsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/persons/payments/plans/$planId/parcels/': {
      id: '/_authenticated/persons/payments/plans/$planId/parcels/'
      path: '/persons/payments/plans/$planId/parcels'
      fullPath: '/persons/payments/plans/$planId/parcels/'
      preLoaderRoute: typeof AuthenticatedPersonsPaymentsPlansPlanIdParcelsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/individual-payment/$financialPersonId/parcels/$parcelId/edit/': {
      id: '/_authenticated/individual-payment/$financialPersonId/parcels/$parcelId/edit/'
      path: '/individual-payment/$financialPersonId/parcels/$parcelId/edit'
      fullPath: '/individual-payment/$financialPersonId/parcels/$parcelId/edit/'
      preLoaderRoute: typeof AuthenticatedIndividualPaymentFinancialPersonIdParcelsParcelIdEditIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/series/$serieId/videos/$videoId/langs/create/': {
      id: '/_authenticated/series/$serieId/videos/$videoId/langs/create/'
      path: '/series/$serieId/videos/$videoId/langs/create'
      fullPath: '/series/$serieId/videos/$videoId/langs/create/'
      preLoaderRoute: typeof AuthenticatedSeriesSerieIdVideosVideoIdLangsCreateIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/series/$serieId/videos/$videoId/langs/$langId/': {
      id: '/_authenticated/series/$serieId/videos/$videoId/langs/$langId/'
      path: '/series/$serieId/videos/$videoId/langs/$langId'
      fullPath: '/series/$serieId/videos/$videoId/langs/$langId/'
      preLoaderRoute: typeof AuthenticatedSeriesSerieIdVideosVideoIdLangsLangIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/exam/revision/$examId/languages/$langId/translate/': {
      id: '/_authenticated/exam/revision/$examId/languages/$langId/translate/'
      path: '/exam/revision/$examId/languages/$langId/translate'
      fullPath: '/exam/revision/$examId/languages/$langId/translate/'
      preLoaderRoute: typeof AuthenticatedExamRevisionExamIdLanguagesLangIdTranslateIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedAccessManagementIndexRoute: typeof AuthenticatedAccessManagementIndexRoute
  AuthenticatedBannersIndexRoute: typeof AuthenticatedBannersIndexRoute
  AuthenticatedClassModulesIndexRoute: typeof AuthenticatedClassModulesIndexRoute
  AuthenticatedClassPlanningIndexRoute: typeof AuthenticatedClassPlanningIndexRoute
  AuthenticatedEnrollmentsIndexRoute: typeof AuthenticatedEnrollmentsIndexRoute
  AuthenticatedExamsIndexRoute: typeof AuthenticatedExamsIndexRoute
  AuthenticatedIndividualPaymentIndexRoute: typeof AuthenticatedIndividualPaymentIndexRoute
  AuthenticatedNotificationIndexRoute: typeof AuthenticatedNotificationIndexRoute
  AuthenticatedPersonsIndexRoute: typeof AuthenticatedPersonsIndexRoute
  AuthenticatedQuestionLibraryIndexRoute: typeof AuthenticatedQuestionLibraryIndexRoute
  AuthenticatedSeriesIndexRoute: typeof AuthenticatedSeriesIndexRoute
  AuthenticatedSlideEditorIndexRoute: typeof AuthenticatedSlideEditorIndexRoute
  AuthenticatedSlideLibraryIndexRoute: typeof AuthenticatedSlideLibraryIndexRoute
  AuthenticatedTutorAiIndexRoute: typeof AuthenticatedTutorAiIndexRoute
  AuthenticatedUnauthorizedIndexRoute: typeof AuthenticatedUnauthorizedIndexRoute
  AuthenticatedAccessManagementRoleIdIndexRoute: typeof AuthenticatedAccessManagementRoleIdIndexRoute
  AuthenticatedBannersBannerIdIndexRoute: typeof AuthenticatedBannersBannerIdIndexRoute
  AuthenticatedBannersCreateIndexRoute: typeof AuthenticatedBannersCreateIndexRoute
  AuthenticatedClassModulesIdIndexRoute: typeof AuthenticatedClassModulesIdIndexRoute
  AuthenticatedClassModulesCreateIndexRoute: typeof AuthenticatedClassModulesCreateIndexRoute
  AuthenticatedEnrollmentsEnrollmentIdIndexRoute: typeof AuthenticatedEnrollmentsEnrollmentIdIndexRoute
  AuthenticatedEnrollmentsBatchStatusIndexRoute: typeof AuthenticatedEnrollmentsBatchStatusIndexRoute
  AuthenticatedExamCorrectionDashboardIndexRoute: typeof AuthenticatedExamCorrectionDashboardIndexRoute
  AuthenticatedExamGradeConfigIndexRoute: typeof AuthenticatedExamGradeConfigIndexRoute
  AuthenticatedExamRevisionIndexRoute: typeof AuthenticatedExamRevisionIndexRoute
  AuthenticatedExamsIdIndexRoute: typeof AuthenticatedExamsIdIndexRoute
  AuthenticatedExamsCreateIndexRoute: typeof AuthenticatedExamsCreateIndexRoute
  AuthenticatedIndividualPaymentFinancialPersonIdIndexRoute: typeof AuthenticatedIndividualPaymentFinancialPersonIdIndexRoute
  AuthenticatedIndividualPaymentCreateIndexRoute: typeof AuthenticatedIndividualPaymentCreateIndexRoute
  AuthenticatedLocationCitiesIndexRoute: typeof AuthenticatedLocationCitiesIndexRoute
  AuthenticatedLocationCountriesIndexRoute: typeof AuthenticatedLocationCountriesIndexRoute
  AuthenticatedLocationStatesIndexRoute: typeof AuthenticatedLocationStatesIndexRoute
  AuthenticatedNotificationIdIndexRoute: typeof AuthenticatedNotificationIdIndexRoute
  AuthenticatedNotificationCreateIndexRoute: typeof AuthenticatedNotificationCreateIndexRoute
  AuthenticatedPersonsIdIndexRoute: typeof AuthenticatedPersonsIdIndexRoute
  AuthenticatedPersonsCreateIndexRoute: typeof AuthenticatedPersonsCreateIndexRoute
  AuthenticatedPersonsPaymentsIndexRoute: typeof AuthenticatedPersonsPaymentsIndexRoute
  AuthenticatedQuestionLibraryQuestionIdIndexRoute: typeof AuthenticatedQuestionLibraryQuestionIdIndexRoute
  AuthenticatedQuestionLibraryNewIndexRoute: typeof AuthenticatedQuestionLibraryNewIndexRoute
  AuthenticatedSeriesSerieIdIndexRoute: typeof AuthenticatedSeriesSerieIdIndexRoute
  AuthenticatedSeriesCreateIndexRoute: typeof AuthenticatedSeriesCreateIndexRoute
  AuthenticatedTutorAiClassesIndexRoute: typeof AuthenticatedTutorAiClassesIndexRoute
  AuthenticatedTutorAiConfigIndexRoute: typeof AuthenticatedTutorAiConfigIndexRoute
  AuthenticatedTutorAiStudentsIndexRoute: typeof AuthenticatedTutorAiStudentsIndexRoute
  AuthenticatedTutorAiUsageIndexRoute: typeof AuthenticatedTutorAiUsageIndexRoute
  AuthenticatedExamCorrectionExamPublishIdIndexRoute: typeof AuthenticatedExamCorrectionExamPublishIdIndexRoute
  AuthenticatedExamsIdLanguagesIndexRoute: typeof AuthenticatedExamsIdLanguagesIndexRoute
  AuthenticatedExamsIdPreviewIndexRoute: typeof AuthenticatedExamsIdPreviewIndexRoute
  AuthenticatedExamsIdQuestionsIndexRoute: typeof AuthenticatedExamsIdQuestionsIndexRoute
  AuthenticatedIndividualPaymentFinancialPersonIdConsolidationIndexRoute: typeof AuthenticatedIndividualPaymentFinancialPersonIdConsolidationIndexRoute
  AuthenticatedIndividualPaymentFinancialPersonIdParcelsIndexRoute: typeof AuthenticatedIndividualPaymentFinancialPersonIdParcelsIndexRoute
  AuthenticatedPersonsIdPaymentsIndexRoute: typeof AuthenticatedPersonsIdPaymentsIndexRoute
  AuthenticatedPersonsIdResumeIndexRoute: typeof AuthenticatedPersonsIdResumeIndexRoute
  AuthenticatedSeriesSerieIdLangsIndexRoute: typeof AuthenticatedSeriesSerieIdLangsIndexRoute
  AuthenticatedSeriesSerieIdVideosIndexRoute: typeof AuthenticatedSeriesSerieIdVideosIndexRoute
  AuthenticatedTutorAiClassesClassStudentIdIndexRoute: typeof AuthenticatedTutorAiClassesClassStudentIdIndexRoute
  AuthenticatedTutorAiStudentsPersonIdIndexRoute: typeof AuthenticatedTutorAiStudentsPersonIdIndexRoute
  AuthenticatedExamRevisionExamIdLanguagesIndexRoute: typeof AuthenticatedExamRevisionExamIdLanguagesIndexRoute
  AuthenticatedExamRevisionExamIdReviewIndexRoute: typeof AuthenticatedExamRevisionExamIdReviewIndexRoute
  AuthenticatedExamRevisionExamIdVisualizeIndexRoute: typeof AuthenticatedExamRevisionExamIdVisualizeIndexRoute
  AuthenticatedIndividualPaymentFinancialPersonIdParcelsCreateIndexRoute: typeof AuthenticatedIndividualPaymentFinancialPersonIdParcelsCreateIndexRoute
  AuthenticatedLocationCountriesCountryIdLangsIndexRoute: typeof AuthenticatedLocationCountriesCountryIdLangsIndexRoute
  AuthenticatedPersonsPaymentsPlansPlanIdIndexRoute: typeof AuthenticatedPersonsPaymentsPlansPlanIdIndexRoute
  AuthenticatedSeriesSerieIdLangsLangIdIndexRoute: typeof AuthenticatedSeriesSerieIdLangsLangIdIndexRoute
  AuthenticatedSeriesSerieIdLangsCreateIndexRoute: typeof AuthenticatedSeriesSerieIdLangsCreateIndexRoute
  AuthenticatedSeriesSerieIdVideosVideoIdIndexRoute: typeof AuthenticatedSeriesSerieIdVideosVideoIdIndexRoute
  AuthenticatedSeriesSerieIdVideosCreateIndexRoute: typeof AuthenticatedSeriesSerieIdVideosCreateIndexRoute
  AuthenticatedIndividualPaymentFinancialPersonIdParcelsParcelIdEditIndexRoute: typeof AuthenticatedIndividualPaymentFinancialPersonIdParcelsParcelIdEditIndexRoute
  AuthenticatedPersonsPaymentsPlansPlanIdParcelsIndexRoute: typeof AuthenticatedPersonsPaymentsPlansPlanIdParcelsIndexRoute
  AuthenticatedSeriesSerieIdVideosVideoIdLangsIndexRoute: typeof AuthenticatedSeriesSerieIdVideosVideoIdLangsIndexRoute
  AuthenticatedExamRevisionExamIdLanguagesLangIdTranslateIndexRoute: typeof AuthenticatedExamRevisionExamIdLanguagesLangIdTranslateIndexRoute
  AuthenticatedSeriesSerieIdVideosVideoIdLangsLangIdIndexRoute: typeof AuthenticatedSeriesSerieIdVideosVideoIdLangsLangIdIndexRoute
  AuthenticatedSeriesSerieIdVideosVideoIdLangsCreateIndexRoute: typeof AuthenticatedSeriesSerieIdVideosVideoIdLangsCreateIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedAccessManagementIndexRoute:
    AuthenticatedAccessManagementIndexRoute,
  AuthenticatedBannersIndexRoute: AuthenticatedBannersIndexRoute,
  AuthenticatedClassModulesIndexRoute: AuthenticatedClassModulesIndexRoute,
  AuthenticatedClassPlanningIndexRoute: AuthenticatedClassPlanningIndexRoute,
  AuthenticatedEnrollmentsIndexRoute: AuthenticatedEnrollmentsIndexRoute,
  AuthenticatedExamsIndexRoute: AuthenticatedExamsIndexRoute,
  AuthenticatedIndividualPaymentIndexRoute:
    AuthenticatedIndividualPaymentIndexRoute,
  AuthenticatedNotificationIndexRoute: AuthenticatedNotificationIndexRoute,
  AuthenticatedPersonsIndexRoute: AuthenticatedPersonsIndexRoute,
  AuthenticatedQuestionLibraryIndexRoute:
    AuthenticatedQuestionLibraryIndexRoute,
  AuthenticatedSeriesIndexRoute: AuthenticatedSeriesIndexRoute,
  AuthenticatedSlideEditorIndexRoute: AuthenticatedSlideEditorIndexRoute,
  AuthenticatedSlideLibraryIndexRoute: AuthenticatedSlideLibraryIndexRoute,
  AuthenticatedTutorAiIndexRoute: AuthenticatedTutorAiIndexRoute,
  AuthenticatedUnauthorizedIndexRoute: AuthenticatedUnauthorizedIndexRoute,
  AuthenticatedAccessManagementRoleIdIndexRoute:
    AuthenticatedAccessManagementRoleIdIndexRoute,
  AuthenticatedBannersBannerIdIndexRoute:
    AuthenticatedBannersBannerIdIndexRoute,
  AuthenticatedBannersCreateIndexRoute: AuthenticatedBannersCreateIndexRoute,
  AuthenticatedClassModulesIdIndexRoute: AuthenticatedClassModulesIdIndexRoute,
  AuthenticatedClassModulesCreateIndexRoute:
    AuthenticatedClassModulesCreateIndexRoute,
  AuthenticatedEnrollmentsEnrollmentIdIndexRoute:
    AuthenticatedEnrollmentsEnrollmentIdIndexRoute,
  AuthenticatedEnrollmentsBatchStatusIndexRoute:
    AuthenticatedEnrollmentsBatchStatusIndexRoute,
  AuthenticatedExamCorrectionDashboardIndexRoute:
    AuthenticatedExamCorrectionDashboardIndexRoute,
  AuthenticatedExamGradeConfigIndexRoute:
    AuthenticatedExamGradeConfigIndexRoute,
  AuthenticatedExamRevisionIndexRoute: AuthenticatedExamRevisionIndexRoute,
  AuthenticatedExamsIdIndexRoute: AuthenticatedExamsIdIndexRoute,
  AuthenticatedExamsCreateIndexRoute: AuthenticatedExamsCreateIndexRoute,
  AuthenticatedIndividualPaymentFinancialPersonIdIndexRoute:
    AuthenticatedIndividualPaymentFinancialPersonIdIndexRoute,
  AuthenticatedIndividualPaymentCreateIndexRoute:
    AuthenticatedIndividualPaymentCreateIndexRoute,
  AuthenticatedLocationCitiesIndexRoute: AuthenticatedLocationCitiesIndexRoute,
  AuthenticatedLocationCountriesIndexRoute:
    AuthenticatedLocationCountriesIndexRoute,
  AuthenticatedLocationStatesIndexRoute: AuthenticatedLocationStatesIndexRoute,
  AuthenticatedNotificationIdIndexRoute: AuthenticatedNotificationIdIndexRoute,
  AuthenticatedNotificationCreateIndexRoute:
    AuthenticatedNotificationCreateIndexRoute,
  AuthenticatedPersonsIdIndexRoute: AuthenticatedPersonsIdIndexRoute,
  AuthenticatedPersonsCreateIndexRoute: AuthenticatedPersonsCreateIndexRoute,
  AuthenticatedPersonsPaymentsIndexRoute:
    AuthenticatedPersonsPaymentsIndexRoute,
  AuthenticatedQuestionLibraryQuestionIdIndexRoute:
    AuthenticatedQuestionLibraryQuestionIdIndexRoute,
  AuthenticatedQuestionLibraryNewIndexRoute:
    AuthenticatedQuestionLibraryNewIndexRoute,
  AuthenticatedSeriesSerieIdIndexRoute: AuthenticatedSeriesSerieIdIndexRoute,
  AuthenticatedSeriesCreateIndexRoute: AuthenticatedSeriesCreateIndexRoute,
  AuthenticatedTutorAiClassesIndexRoute: AuthenticatedTutorAiClassesIndexRoute,
  AuthenticatedTutorAiConfigIndexRoute: AuthenticatedTutorAiConfigIndexRoute,
  AuthenticatedTutorAiStudentsIndexRoute:
    AuthenticatedTutorAiStudentsIndexRoute,
  AuthenticatedTutorAiUsageIndexRoute: AuthenticatedTutorAiUsageIndexRoute,
  AuthenticatedExamCorrectionExamPublishIdIndexRoute:
    AuthenticatedExamCorrectionExamPublishIdIndexRoute,
  AuthenticatedExamsIdLanguagesIndexRoute:
    AuthenticatedExamsIdLanguagesIndexRoute,
  AuthenticatedExamsIdPreviewIndexRoute: AuthenticatedExamsIdPreviewIndexRoute,
  AuthenticatedExamsIdQuestionsIndexRoute:
    AuthenticatedExamsIdQuestionsIndexRoute,
  AuthenticatedIndividualPaymentFinancialPersonIdConsolidationIndexRoute:
    AuthenticatedIndividualPaymentFinancialPersonIdConsolidationIndexRoute,
  AuthenticatedIndividualPaymentFinancialPersonIdParcelsIndexRoute:
    AuthenticatedIndividualPaymentFinancialPersonIdParcelsIndexRoute,
  AuthenticatedPersonsIdPaymentsIndexRoute:
    AuthenticatedPersonsIdPaymentsIndexRoute,
  AuthenticatedPersonsIdResumeIndexRoute:
    AuthenticatedPersonsIdResumeIndexRoute,
  AuthenticatedSeriesSerieIdLangsIndexRoute:
    AuthenticatedSeriesSerieIdLangsIndexRoute,
  AuthenticatedSeriesSerieIdVideosIndexRoute:
    AuthenticatedSeriesSerieIdVideosIndexRoute,
  AuthenticatedTutorAiClassesClassStudentIdIndexRoute:
    AuthenticatedTutorAiClassesClassStudentIdIndexRoute,
  AuthenticatedTutorAiStudentsPersonIdIndexRoute:
    AuthenticatedTutorAiStudentsPersonIdIndexRoute,
  AuthenticatedExamRevisionExamIdLanguagesIndexRoute:
    AuthenticatedExamRevisionExamIdLanguagesIndexRoute,
  AuthenticatedExamRevisionExamIdReviewIndexRoute:
    AuthenticatedExamRevisionExamIdReviewIndexRoute,
  AuthenticatedExamRevisionExamIdVisualizeIndexRoute:
    AuthenticatedExamRevisionExamIdVisualizeIndexRoute,
  AuthenticatedIndividualPaymentFinancialPersonIdParcelsCreateIndexRoute:
    AuthenticatedIndividualPaymentFinancialPersonIdParcelsCreateIndexRoute,
  AuthenticatedLocationCountriesCountryIdLangsIndexRoute:
    AuthenticatedLocationCountriesCountryIdLangsIndexRoute,
  AuthenticatedPersonsPaymentsPlansPlanIdIndexRoute:
    AuthenticatedPersonsPaymentsPlansPlanIdIndexRoute,
  AuthenticatedSeriesSerieIdLangsLangIdIndexRoute:
    AuthenticatedSeriesSerieIdLangsLangIdIndexRoute,
  AuthenticatedSeriesSerieIdLangsCreateIndexRoute:
    AuthenticatedSeriesSerieIdLangsCreateIndexRoute,
  AuthenticatedSeriesSerieIdVideosVideoIdIndexRoute:
    AuthenticatedSeriesSerieIdVideosVideoIdIndexRoute,
  AuthenticatedSeriesSerieIdVideosCreateIndexRoute:
    AuthenticatedSeriesSerieIdVideosCreateIndexRoute,
  AuthenticatedIndividualPaymentFinancialPersonIdParcelsParcelIdEditIndexRoute:
    AuthenticatedIndividualPaymentFinancialPersonIdParcelsParcelIdEditIndexRoute,
  AuthenticatedPersonsPaymentsPlansPlanIdParcelsIndexRoute:
    AuthenticatedPersonsPaymentsPlansPlanIdParcelsIndexRoute,
  AuthenticatedSeriesSerieIdVideosVideoIdLangsIndexRoute:
    AuthenticatedSeriesSerieIdVideosVideoIdLangsIndexRoute,
  AuthenticatedExamRevisionExamIdLanguagesLangIdTranslateIndexRoute:
    AuthenticatedExamRevisionExamIdLanguagesLangIdTranslateIndexRoute,
  AuthenticatedSeriesSerieIdVideosVideoIdLangsLangIdIndexRoute:
    AuthenticatedSeriesSerieIdVideosVideoIdLangsLangIdIndexRoute,
  AuthenticatedSeriesSerieIdVideosVideoIdLangsCreateIndexRoute:
    AuthenticatedSeriesSerieIdVideosVideoIdLangsCreateIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginIndexRoute: LoginIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
